module.exports = __webpack_public_path__ + "fonts/TBCSailec-Medium.4b45844c.woff2";